<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <li
    v-if="!editing"
    class="relative col-span-1 divide-y divide-font-lightest rounded-lg bg-white shadow-lg">
    <div class="flex w-full items-center justify-between space-x-6 p-6">
      <div class="flex-1 truncate">
        <div class="">
          <span
            v-if="recentlySuccessful"
            class="absolute right-5 top-2 font-semibold text-success">Saved</span>
          <button
            v-else
            type="button"
            class="absolute right-1 top-2"
            @click="open">
            <svg
              class="-ml-1 mr-3 size-6 shrink-0 text-font-light group-hover:text-font"
              x-state-description="undefined: &quot;text-teal-500 group-hover:text-teal-500&quot;, undefined: &quot;text-gray-400 group-hover:text-gray-500&quot;"
              x-description="Heroicon name: outline/cog"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </button>
        </div>
        <div class="mb-3 mt-2 flex items-center space-x-3">
          <h3 class=" truncate text-sm font-medium text-font-darkest">
            {{ contact.name }}
          </h3>
          <span
            v-if="isPrimary()"
            class="inline-block shrink-0 rounded-full bg-success px-3 py-0.5 text-xs font-medium font-semibold text-white">Primary Contact</span>
        </div>
        <p class="mt-1 truncate text-sm text-font">
          {{ contact.position }}
        </p>
        <p class="mt-1 truncate text-sm text-font">
          {{ contact.email }}
        </p>
        <p class="mt-1 truncate text-sm text-font">
          {{ contact.phone }}
        </p>
      </div>
    </div>
    <div>
      <div class="-mt-px flex divide-x divide-font-lightest">
        <div class="flex w-0 flex-1">
          <a
            :href="'tel:' + contact.phone"
            class="relative -mr-px inline-flex w-0 flex-1 items-center justify-center rounded-bl-lg border border-transparent py-4 text-sm font-medium text-gray-700 hover:text-gray-500"
            :class="{'cursor-not-allowed opacity-25 hover:text-gray-700' : contact.phone === null }">
            <svg
              class="size-5 text-font-light"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true">
              <path d="M17.924 2.617a.997.997 0 00-.215-.322l-.004-.004A.997.997 0 0017 2h-4a1 1 0 100 2h1.586l-3.293 3.293a1 1 0 001.414 1.414L16 5.414V7a1 1 0 102 0V3a.997.997 0 00-.076-.383z" />
              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
            </svg>
            <span class="ml-3">Call</span>
          </a>
        </div>
        <div class="-ml-px flex w-0 flex-1">
          <a
            :href="'mailto:' + contact.email"
            class="relative inline-flex w-0 flex-1 items-center justify-center rounded-br-lg border border-transparent py-4 text-sm font-medium text-gray-700 hover:text-gray-500">
            <svg
              class="-ml-1 mr-2 size-5 text-font-light"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true">
              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
            </svg>
            <span class="ml-3">Email</span>
          </a>
        </div>
      </div>
    </div>
  </li>

  <li
    v-else
    class="col-span-1 divide-y divide-gray-200 rounded-lg bg-white shadow">
    <div class="flex w-full items-center justify-between space-x-6 p-6 pb-3">
      <div class="flex-1 truncate">
        <div class="flex items-center space-x-3">
          <input
            id="name"
            v-model="form.name"
            type="text"
            name="name"
            class="block w-full max-w-lg rounded-md border-font-lightest p-1 shadow-sm focus:border-primary focus:ring-primary sm:max-w-xs sm:text-sm"
            :class="{'border-red-300': form.errors.name }">
          <p
            v-if="form.errors.name"
            class="absolute mt-1 text-xs text-red-600">
            {{ form.errors.name }}
          </p>
        </div>
        <input
          id="position"
          v-model="form.position"
          type="text"
          name="position"
          class="block w-full max-w-lg rounded-md border-font-lightest p-1 shadow-sm focus:border-primary focus:ring-primary sm:max-w-xs sm:text-sm"
          :class="{'border-red-300': form.errors.position }">
        <p
          v-if="form.errors.position"
          class="absolute mt-1 text-xs text-red-600">
          {{ form.errors.position }}
        </p>
        <input
          id="email"
          v-model="form.email"
          type="text"
          name="email"
          class="block w-full max-w-lg rounded-md border-font-lightest p-1 shadow-sm focus:border-primary focus:ring-primary sm:max-w-xs sm:text-sm"
          :class="{'border-red-300': form.errors.email }">
        <p
          v-if="form.errors.email"
          class="absolute mt-1 text-xs text-red-600">
          {{ form.errors.email }}
        </p>
        <input
          id="phone"
          v-model="form.phone"
          type="text"
          name="phone"
          class="block w-full max-w-lg rounded-md border-font-lightest p-1 shadow-sm focus:border-primary focus:ring-primary sm:max-w-xs sm:text-sm"
          :class="{'border-red-300': form.errors.phone }">
        <p
          v-if="form.errors.phone"
          class="absolute mt-1 text-xs text-red-600">
          {{ form.errors.phone }}
        </p>
      </div>
    </div>
    <div class="flex justify-end space-x-1 whitespace-nowrap px-3 py-2 text-right text-sm font-medium">
      <button
        :class="{ 'opacity-25': form.processing }"
        :disabled="form.processing"
        type="button"
        class="inline-flex justify-center rounded-md border border-success bg-success px-2 py-1 text-xs font-medium text-white shadow-sm hover:bg-success-dark focus:outline-none focus:ring-2 focus:ring-success-dark focus:ring-offset-2"
        @click="save">
        <svg
          class="-mx-1 size-5 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M5 13l4 4L19 7" />
        </svg>
      </button>
      <button
        type="button"
        class="inline-flex justify-center rounded-md border border-warning bg-warning px-2 py-1 text-xs font-medium text-white shadow-sm hover:bg-warning-dark focus:outline-none focus:ring-2 focus:ring-warning-dark focus:ring-offset-2"
        @click="cancel">
        <svg
          class="-mx-1 size-5 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      <button
        type="button"
        class="inline-flex justify-center rounded-md border border-danger bg-danger px-2 py-1 text-xs font-medium text-white shadow-sm hover:bg-danger-dark focus:outline-none focus:ring-2 focus:ring-danger-dark focus:ring-offset-2"
        @click="delete">
        Delete
      </button>
    </div>
    <div />
  </li>
</template>

<script>

export default {
  props: [
    'contact',
    'client',
  ],

  emits: ['submitted'],
  data() {
    return {
      editing: false,
      initial_value: null,
      saved: false,
      form: this.$inertia.form({
        name: this.contact.name,
        position: this.contact.position,
        email: this.contact.email,
        phone: this.contact.phone,
        primary_contact: this.contact.id,
      }),
    };
  },

  computed: {
    recentlySuccessful() {
      return this.saved && this.form.recentlySuccessful;
    },
  },

  watch: {
    recentlySuccessful(val, oldVal) {
      if (val === true) {
        this.editing = false;
      }
    },
  },

  methods: {
    cancel() {
      this.form.name = this.contact.name;
      this.form.position = this.contact.position;
      this.form.email = this.contact.email;
      this.form.phone = this.contact.phone;
      this.form.clearErrors();
      this.saved = false;
      this.editing = false;
    },

    open() {
      this.form.name = this.contact.name;
      this.form.position = this.contact.position;
      this.form.email = this.contact.email;
      this.form.phone = this.contact.phone;
      this.saved = false;
      this.editing = true;
    },

    save() {
      this.saved = true;
      this.form.put(route('contacts.update', { contact: this.contact.id }), {
        errorBag: 'updateContact',
        preserveScroll: true,
        onSuccess: () => {
          this.$notify({
            type: 'success',
            title: 'Updated',
            text: 'The contact was updated',
          }, 4000);
        },
        onError: () => {
          this.$notify({
            type: 'danger',
            title: 'Something went wrong',
            text: 'Could not update the contact',
          }, 4000);
        },
      });
      this.$emit('submitted');
    },

    delete() {
      this.editing = false;
      this.$inertia.delete(route('contacts.delete', { contact: this.contact.id })).then((response) => {
        if (response.status === 200) {
          console.log('success');
        } else {
          console.log('error');
        }
      });
    },

    isPrimary() {
      return this.client.primary_contact === this.contact.id;
    },
  },
};
</script>
